import { useState } from 'react';

function useFilters<T>(currentFilters: T): [T, React.Dispatch<React.SetStateAction<T>>] {
    const [filters, setFilters] = useState(currentFilters);

    return [filters, setFilters];
}

export default useFilters;
